import { useState } from "react";
import { useHelperFunction } from "../utils/helperFuntion";
import Layout from "../Components/Layout/Layout";
import ProjectItem from "../Components/ProjectItem";
import Me from "../assets/images/Inan Celis with Laptop.png";
import "../assets/styles/home.scss";
import RainbowSwirl from "../Components/RainbowSwirl";
import MouseScroll from "../Components/Slice/MouseScroll";
import HomeIntro from "../Components/HomeIntro";
import Details from "../Components/Details";
import Work from "../Components/Work";
import Expertise from "../Components/Expertise";
import Skills from "../Components/Skills";
import SEO from "../Components/SEO";
import ResumeButton from "../Components/Slice/ResumeButton";
import WhyTrustMe from "../Components/WhyTrustMe";
import CallToAction from "../Components/CallToAction";
import FAQ from "../Components/FAQ";
import LeadPopup from "../Components/Slice/LeadPopup";
// import FounderBanner from "../Components/FounderBanner";
import TestimonialVideo from "../Components/TestimonialVideo";
import AgencyProjects from "../Components/AgencyProjects";
import { NavLink } from "react-router-dom";


const structuredData = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Ferdinand T. Celis (Inan Celis)",
  alternateName: "Inan Celis",
  url: "https://inancelis.com/",
  image: `https://inancelis.com${Me}`,
  jobTitle: "Web Developer",
  description:
    "Website developer in the Philippines specializing in WordPress, WooCommerce, React, Vue, and full-stack web development",
  address: {
    "@type": "PostalAddress",
    addressCountry: "Philippines",
  },
  worksFor: {
    "@type": "Organization",
    name: "Freelance",
  },
  sameAs: ["https://github.com/inancelis", "https://linkedin.com/in/inancelis"],
  knowsAbout: [
    "WordPress",
    "WooCommerce",
    "PHP",
    "Laravel",
    "JavaScript",
    "React",
    "Vue",
    "Web Development",
    "Frontend Development",
    "Backend Development",
  ],
  alumniOf: {
    "@type": "EducationalOrganization",
    name: "Bachelor of Science in Information Technology",
  },
};

function Home() {
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  useHelperFunction("");
  return (
    <Layout>
      <LeadPopup open={calendlyOpen} onClose={() => setCalendlyOpen(false)} />
      <SEO
        title="Web Developer Philippines | WordPress & Full-Stack | Inan Celis"
        description="Website developer in the Philippines specializing in WordPress, WooCommerce, React, Vue, and full-stack web development. Building fast, professional websites for businesses."
        url="https://inancelis.com/"
        structuredData={structuredData}
      />
      <div className="d-none d-md-block">
        <RainbowSwirl position={"Absolute"} />
      </div>
      <div className="container">
        <HomeIntro photo={Me} onBook={() => setCalendlyOpen(true)} />
        <MouseScroll />
      </div>
      {/* <div>
        <FounderBanner />
      </div> */}
      <div className="margin-top-big">
        <TestimonialVideo />
      </div>
      <div className="margin-top-big">
        <AgencyProjects />
      </div>
      <div>
        <ProjectItem
          itemCount={3}
          viewAll={true}
          hasObject={null}
          otherItem={false}
          title={true}
        />
      </div>
      <div className="margin-top-big">
        <WhyTrustMe />
      </div>
      <div className="margin-top-big padding-mobile">
        <Details />
      </div>

      <div className="margin-top-big">
        <Expertise />
      </div>
      <div className="margin-top-big">
        <Skills />
      </div>
      <div className="margin-top-big">
        <Work />
      </div>
      <div className="d-flex justify-content-center pb-5">
        {/* <ResumeButton /> */}
        <NavLink to="/inan-celis-resume/" className="button-52 button">
          View Virtual CV &nbsp;<i className="fa-solid fa-id-card"></i>
        </NavLink>
      </div>
      <div className="margin-top-big">
        <CallToAction />
      </div>
      <div className="margin-top-big">
        <FAQ />
      </div>
    </Layout>
  );
}

export default Home;
